module.exports = __webpack_public_path__ + "img/company4-2.41e737d5.jpg";